import {
  GeolocateControl,
  Map as MapLib,
  NavigationControl,
} from "maplibre-gl";
import { drawControlsStateManager } from "../../../globals";

export const setupControls = (map: MapLib) => {
  map.addControl(
    new NavigationControl({ showCompass: true, visualizePitch: true }),
    "bottom-right",
  );

  drawControlsStateManager.addDrawControls(map);

  // map.addControl(new MeasureControl(), "bottom-right");

  map.addControl(
    new GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: true,
    }),
    "bottom-right",
  );
};
